import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconPin = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconPin.dimensions.width} ${IconPin.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M18 5.598c-.305.364-.583.747-.914 1.086-.391.395-.71.37-1.425-.032-.072.063-.159.126-.231.201-.954.948-1.915 1.896-2.85 2.862-.145.15-.251.408-.258.621-.033.704 0 1.413-.013 2.122-.02.96-1.1 1.795-1.895 1.469-.192-.076-.364-.22-.51-.364-.815-.804-1.623-1.62-2.45-2.448-.1.088-.193.163-.273.245-2.186 2.184-4.372 4.368-6.558 6.558-.027.025-.04.063-.06.094H0v-.558c.55-.54 1.1-1.073 1.65-1.613 1.749-1.739 3.491-3.483 5.266-5.26-.483-.483-.954-.947-1.424-1.418-.378-.377-.762-.747-1.133-1.13-.49-.502-.477-1.104-.02-1.638.431-.502.934-.747 1.61-.697.596.044 1.2.02 1.796 0a.667.667 0 0 0 .424-.15c1.04-1.017 2.06-2.046 3.087-3.075.033-.038.06-.088.08-.126-.504-.897-.233-1.613.82-2.19.08-.044.153-.088.233-.138h.563c.291.225.603.426.861.677a253.8 253.8 0 0 1 3.498 3.496c.258.258.457.571.682.866v.559L18 5.598Zm-1.444.716c.152-.201.298-.427.483-.622.252-.263.272-.483 0-.747-1.331-1.324-2.656-2.66-3.995-3.972-.119-.113-.417-.226-.503-.164-.285.22-.517.509-.762.779-.013.012.046.087.073.138.345.59.305.885-.179 1.374-.94.942-1.895 1.877-2.822 2.83-.351.365-.742.528-1.239.51-.65-.026-1.305-.007-1.96 0-.306 0-.856.35-.869.645-.013.201.16.452.312.616.536.57 1.106 1.117 1.662 1.675a388.297 388.297 0 0 0 3.657 3.64c.126.126.424.258.524.195.338-.194.656-.446.636-.929-.027-.665 0-1.33-.014-1.996-.013-.433.14-.765.444-1.067.954-.935 1.889-1.882 2.83-2.824.582-.584.874-.615 1.715-.069l.007-.012Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconPin.dimensions = {
  width: 18,
  height: 18,
}

export default IconPin
